import { useQuery } from '@tanstack/react-query';
import { awaitJSON, ToolsLambdaFetch } from '@src/utils/fetch-utils';

// One row of the `streaming_discrepancies` table. The `*_monitored` / `*_total` columns are
// Postgres bigints, which node-postgres returns as strings.
export interface StreamingDiscrepancyRow {
  day: string;
  company: string;
  description: string;
  network: string;
  platform: string;
  details: string;
  yesterday_ratio: number | null;
  yesterday_monitored: string | null;
  yesterday_total: string | null;
  last_week_ratio: number | null;
  last_week_monitored: string | null;
  last_week_total: string | null;
}

export const useStreamingDiscrepancies = (): ReturnType<
  typeof useQuery<StreamingDiscrepancyRow[]>
> =>
  useQuery({
    queryKey: ['streamingDiscrepancies'],
    // The page shows its own error modal.
    meta: { suppressGlobalError: true },
    queryFn: async (): Promise<StreamingDiscrepancyRow[]> =>
      awaitJSON<StreamingDiscrepancyRow[]>(await ToolsLambdaFetch('/streaming_discrepancies'))
  });
